import { get } from 'lodash'
export default {
  computed: {
    hasDirectorList () {
      return this.hasList('directors')
    },
    directorList () {
      return this.getList('directors')
    },
    hasWriterList () {
      return this.hasList('writers')
    },
    writerList () {
      return this.getList('writers')
    },
    hasActorList () {
      return this.hasList('actors')
    },
    actorList () {
      return this.getList('actors')
    }
  },
  methods: {
    getList (keyName) {
      return get(this.contentInfo, [keyName, 'list'], [])
    },
    hasList (keyName) {
      return this.getList(keyName).length > 0 && +get(this.contentInfo, [keyName, 'count'], 0) > 0
    }
  }
}
